export const prevPathKey = 'prevPath'
